import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSecuritySchemesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-security-schemes-delete',
	path: '/secure/admin/DeleteIssueSecurityScheme([!%]?[\\w]*).jspa',
};
